import * as React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { IConversation } from '../../models/IConversation';
import { IProject } from '../../models/IProject';
import { IGetGitHubProjectSettingsParam, IPullProjectFromGithubParam, IPushProjectToGithubParam, IRemoveGitHubProjectSettingsParam, ICheckChangesToPullParam, ICheckChangesToPushParam, ICheckProjectForUnsavedChangesParam, IGetBranchesByRepositoryParam, IGetFilesByBranchParam, IAddFilesToProjectParam, IAddRepoWithoutFilesToProjectParam, IPushTestCasesParam, IAddRepoForCiCdParam, IShowAddGithubRepoUrlPopupParam } from './actions.gitHubIntegration';
import { IBaseAction, IPromiseParam } from '../base';
import { routeInfo } from './../../routeInfo';
import { Provider } from 'react-redux';
import { takeEvery, put, call } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { confirmAlert } from '../../services/mini/alanConfirmAlert';
import * as types from './actionTypes.gitHubIntegration';
import * as userActionTypes from '../user/actionTypes.user';
import * as projectActionTypes from '../projects/actionTypes.projects';
import * as errorSaga from '../errors/saga.errors';
import * as userSaga from '../user/saga.user';
import * as projectsSaga from '../projects/saga.projects';
import * as confirmSaga from '../confirm/saga.confirm';
import Api from '../../api/Api';
import scriptDraftService from '../../services/ScriptDraftService';
import ToasterService from '../../services/ToasterService';
import messages from '../../const/messages';
import store from '../../store';
import { getGitHubToken, clearEncGitHubToken, getEncGitHubToken, clearGitHubTokenAndScope } from '../../services/mini/gitHubToken';
import AddGitHubRepositoryForm from '../../views/pages/project/GitHubIntegration/AddGitHubRepositoryForm/AddGitHubRepositoryForm';
import getUrlInfo from '../../services/mini/getUrlInfo';
import { GitHubApiHttp } from '../../services/GitHubApiHttp';
import * as _ from 'lodash';
import MergeForm from '../../views/pages/project/GitHubIntegration/MergeForm/MergeForm';
import RemoveCiCdLinkAndSaveScriptsToTag, { IRemoveCiCdLinkParam } from '../../views/pages/project/GitHubIntegration/RemoveCiCdLinkAndSaveScriptsToTagForm/RemoveCiCdLinkAndSaveScriptsToTagForm';
import { buildFullRepoUrl, getFilesByPath, getRepoInfo } from '../../services/mini/gitHelpers';
import errorCodes from '../../const/errorCodes';
import Node from '../../classes/Node';
import ChangesToPullForm from '../../views/pages/project/GitHubIntegration/ChangesToPullForm/ChangesToPullForm';
import MergeTestCasesForm from '../../views/pages/project/GitHubIntegration/MergeTestCasesForm/MergeTestCasesForm';
import Dialog from '../../views/pages/project/TestMode/Dialog/Dialog';
import { IScript, isScriptType } from '../../models/IScript';
import { getScriptsHash } from '../../services/mini/getScriptsHash';
import { Environment } from '../../const/environment';

enum MergeStatus {
    Canceled = 'canceled',
    ConflictsResolved = 'resolved',
    NoConflicts = 'no-conflicts',
}

enum RemoveCiCdStatus {
    Canceled = 'canceled',
    SaveWithNewName = 'save-w-new-name',
    SaveWithoutNewName = 'save-wo-new-name',
}


let savedCommitSha = '';

export function* watch() {
    yield takeEvery<IGetGitHubProjectSettingsParam & IBaseAction>(types.GET_GITHUB_PROJECT_SETTINGS_REQ, getGitHubProjectSettings);
    yield takeEvery<IShowAddGithubRepoUrlPopupParam & IBaseAction>(types.SHOW_ADD_GITHUB_REPO_URL_POPUP, showAddGithubRepoUrlPopup);
    yield takeEvery<ISaveGitHubProjectSettingsParam & IBaseAction>(types.SAVE_GITHUB_PROJECT_SETTINGS_REQ, saveGitHubProjectSettings);
    yield takeEvery<IPullProjectFromGithubParam & IBaseAction>(types.PULL_PROJECT_FROM_GITHUB_REQ, pullProjectFromGithub);
    yield takeEvery<IPushProjectToGithubParam & IBaseAction>(types.PUSH_PROJECT_TO_GITHUB_REQ, pushProjectToGithub);
    yield takeEvery<IRemoveGitHubProjectSettingsParam & IBaseAction>(types.REMOVE_GITHUB_PROJECT_SETTINGS_REQ, removeGitHubProjectSettings);
    yield takeEvery<ICheckChangesToPullParam & IBaseAction>(types.CHECK_CHANGES_TO_PULL_FROM_GITHUB_REQ, checkChangesToPull);
    yield takeEvery<ICheckChangesToPushParam & IBaseAction>(types.CHECK_CHANGES_TO_PUSH_TO_GITHUB_REQ, checkChangesToPush);
    yield takeEvery<ICheckProjectForUnsavedChangesParam & IBaseAction>(types.CHECK_FOR_UNSAVED_CHANGES_IN_PROJECT_FOR_GITHUB_REQ, checkProjectForUnsavedChanges);
    yield takeEvery<IBaseAction>(types.GET_REPOSITORIES_BY_USER_REQ, getRepositoriesByUser);
    yield takeEvery<IBaseAction>(types.GET_ORGANIZATIONS_BY_USER_REQ, getOrganizationsByUser);
    yield takeEvery<IGetBranchesByRepositoryParam & IBaseAction>(types.GET_BRANCHES_BY_REPOSITORY_REQ, getBranchesByRepository);
    yield takeEvery<IGetFilesByBranchParam & IBaseAction>(types.GET_FILES_BY_BRANCH_REQ, getFilesByBranch);
    yield takeEvery<IGetFilesByBranchParam & IBaseAction>(types.RESET_BRANCH_AND_FILES_AFTER_SWITCHING_REPO_REQ, resetBranchesAndFilesAfterSwithcingRepos);
    yield takeEvery<IAddFilesToProjectParam & IBaseAction>(types.ADD_FILES_TO_PROJECT_REQ, addFilesToProject);
    yield takeEvery<IAddRepoForCiCdParam & IBaseAction>(types.ADD_REPO_FOR_CI_CD_REQ, addRepoForCiCd);
    yield takeEvery<IAddRepoForCiCdParam & IBaseAction>(types.GET_SCRIPTS_FOR_CI_CD_REQ, getScriptsForCiCd);
    yield takeEvery<IAddRepoWithoutFilesToProjectParam & IBaseAction>(types.ADD_REPO_WITHOUT_FILES_TO_PROJECT_REQ, addRepoWithoutFiles);
    yield takeEvery<IPushTestCasesParam & IBaseAction>(types.PUSH_TEST_CASES_REQ, pushTestCases);
    yield takeEvery<IBaseAction>(types.REVOKE_GITHUB_ACCESS_REQ, revokeGithubAccess);
}

export function* getGitHubProjectSettings({ projectId, testToken, environment, resolve, reject }: IGetGitHubProjectSettingsParam) {
    try {
        const ghToken = getGitHubToken();
        const deployId = environment || '';
        const {
            gitUserProject,
            path,
            repoUrl,
            githubLogin,
            repoPermissions,
            deployId: githubDeployId
        } = yield call(Api.getGitHubProjectSettings, { projectId, deployId });

        let parsedRepoPermissions = {};

        try {
            parsedRepoPermissions = JSON.parse(repoPermissions);
        } catch (e) {
            parsedRepoPermissions = {};
        }

        yield put({
            type: types.GET_GITHUB_PROJECT_SETTINGS_OK,
            gitUserProject,
            path,
            repoUrl,
            githubLogin,
            repoPermissions: parsedRepoPermissions,
            githubDeployId
        });

        if (!ghToken) {
            yield put({
                type: types.GITHUB_CREDENTIALS_ERR,
                hasGithubToken: false,
                hasGithubAccess: false
            });
            return;
        }

        if (testToken !== false) {
            yield call(GitHubApiHttp.testToken);
            yield put({
                type: types.GITHUB_CREDENTIALS_ERR,
                hasGithubToken: true,
                hasGithubAccess: true
            });
        }

        if (resolve) {
            resolve();
        }
    } catch (error) {
        if (reject) {
            reject();
        }
        yield handleGithubIntegrationErrors(error);
    }
}

export function* getOrganizationsByUser() {
    try {
        const { organizations } = yield call(GitHubApiHttp.getOrganizations);
        yield put({ type: types.GET_ORGANIZATIONS_BY_USER_OK, organizations });
    }
    catch (error) {
        yield handleGithubIntegrationErrors(error);
    }
}

export function* getRepositoriesByUser() {
    try {
        const repositoryDepth = 5;
        let repositories = [];

        for (let page = 1; page <= repositoryDepth; page++) {
            const reposFromNewPage = yield getRepositoriesByUserForPage(page);
            repositories = repositories.concat(reposFromNewPage);

            if (reposFromNewPage.length < 100) {
                break;
            }
        }

        repositories = _.sortBy(repositories, 'name');

        yield put({ type: types.GET_REPOSITORIES_BY_USER_OK, repositories });
    }
    catch (error) {
        yield handleGithubIntegrationErrors(error);
    }
}

function* getRepositoriesByUserForPage(page: number) {
    try {
        const { repositories } = yield call(GitHubApiHttp.getRepositories, page);
        return repositories;
    }
    catch (error) {
        yield handleGithubIntegrationErrors(error);
    }
}

export function* getBranchesByRepository({ repo, resolve, reject }: IGetBranchesByRepositoryParam) {
    try {
        const { branches } = yield call(GitHubApiHttp.getBranchesByRepository, repo);
        yield put({ type: types.GET_BRANCHES_BY_REPOSITORY_OK, branches });
        if (resolve) {
            resolve(branches);
        }
        return branches;
    }
    catch (error) {
        if (reject) {
            reject();
        }
        yield handleGithubIntegrationErrors(error);
    }
}

export function* resetBranchesAndFilesAfterSwithcingRepos() {
    yield put({ type: types.RESET_BRANCH_AND_FILES_AFTER_SWITCHING_REPO_OK });
}

export function* getFilesByBranch({ repo, branch, commitSha, secondAttempt, resolve, reject }: IGetFilesByBranchParam) {
    try {
        savedCommitSha = commitSha;
        const { files } = yield call(GitHubApiHttp.getFilesByBranch, repo, commitSha);
        yield put({ type: types.GET_FILES_BY_BRANCH_OK, files });
        resolve(files);
        return files;
    } catch (error) {
        if (!secondAttempt) {
            // If all files were removed from the repo manually,
            // we will be unable to get files from such repo, for this case we
            // can create .gitempty file and make a second try of getFilesByBranch call
            const initFile = {
                path: '.gitempty',
                content: ''
            };
            const { commit } = yield call(GitHubApiHttp.makeInitCommit, repo, 'Add .gitempty file to the repository', branch, initFile);
            yield getFilesByBranch({ repo, branch, commitSha: commit.sha, secondAttempt: true, resolve, reject });
            return;
        }
        reject();
        yield handleGithubIntegrationErrors(error);
    }
}

export function* addRepoForCiCd({ project, repoUrl, folder, branch, environment, resolve, reject }: IAddRepoForCiCdParam) {
    try {
        yield saveGitHubProjectSettings({
            project,
            environment,
            repoUrl: buildFullRepoUrl({ repoUrl, branch, folder })
        });

        yield projectsSaga.getProject({
            projectId: project.projectId,
            environment,
            keepMessages: true,
        });
        if (resolve) {
            resolve();
        }
    } catch (error) {
        if (reject) {
            reject();
        }
        yield handleGithubIntegrationErrors(error);
    }
}

export interface IGetScriptsFromCiCdParam extends IPromiseParam {
    project: IProject, environment: Environment
}

export function* getScriptsForCiCd({ project, environment, resolve, reject }: IGetScriptsFromCiCdParam) {
    try {
        const tagId = project[`${environment}TagId`];
        const scripts = yield projectsSaga.getScripts({
            projectId: project.projectId,
            tagId,
        });

        yield put({ type: projectActionTypes.UPDATE_PROJECT_AFTER_CICD_SYNC_OK });

        const scriptsHash = yield call(getScriptsHash, scripts);

        if (scriptsHash === window.debugInfo.scriptHash) {
            store.dispatch({ type: projectActionTypes.ACTUAL_STATUS_FOR_SCRIPTS_OK, hash: window.debugInfo.scriptHash });
        } else {
            store.dispatch({ type: projectActionTypes.ACTUAL_STATUS_FOR_SCRIPTS_ERR, hash: scriptsHash });
        }

        if (resolve) {
            resolve();
        }
    } catch (error) {
        if (reject) {
            reject();
        }
        yield handleGithubIntegrationErrors(error);
    }
}

export function* addFilesToProject({ project, files, repoUrl, folder, branch, repoPermissions, resolve, reject }: IAddFilesToProjectParam) {
    try {
        const projectId = project.projectId;
        const tagId = project.stageTagId;
        const scripts = yield projectsSaga.getScripts({ projectId, tagId });
        const conversations = yield getConversations({ project });
        for (let i = 0; i < files.length; i++) {
            files[i].content = yield call(GitHubApiHttp.getFileContent, files[i].url);
        }
        const { scriptsFiles, testCasesFiles } = getScriptsAndTestCasesFromFiles(files);

        const {
            filesWithConflicts: scriptsWithConflicts,
        } = getDiffBetweenProjectAndRepo(scripts, files);

        const scriptsMergeResult: IResolveConflictResults = yield resolveConflictsInScripts({
            files: scriptsFiles,
            scripts,
            message: "You have conflicts between scripts in your project and files from the remote repository: " + scriptsWithConflicts.map(script => `<b>${script.name}</b>`).join(', ') + ". What would you like to do?",
        });

        if (scriptsMergeResult.status === MergeStatus.ConflictsResolved ||
            scriptsMergeResult.status === MergeStatus.NoConflicts) {
            yield saveScripts({
                project,
                scriptsToAdd: scriptsMergeResult.itemsToAdd,
                scriptsToUpdate: scriptsMergeResult.itemsToUpdated,
                repoUrl,
                folder,
                branch,
                repoPermissions
            });
            yield put({ type: projectActionTypes.UPDATE_PROJECT_AFTER_MERGE_OK });
        }
        if (scriptsMergeResult.status === MergeStatus.Canceled) {
            yield put({ type: types.PULL_PROJECT_FROM_GITHUB_OK });

            if (resolve) {
                resolve();
            }
            return;
        }

        const testCasesMergeResult: IResolveConflictResults = yield resolveConflictsInTestCases({
            files: testCasesFiles,
            addRepo: true,
            conversations
        });

        if (testCasesMergeResult.status === MergeStatus.ConflictsResolved ||
            testCasesMergeResult.status === MergeStatus.NoConflicts) {
            yield projectsSaga.importTestConversations({
                project,
                conversations: [
                    ...getConversationsFromRepoFiles(testCasesMergeResult.itemsToAdd),
                    ...(testCasesMergeResult.itemsToUpdated || []),
                ],
                initializerInfo: 'git'
            });
        }

        if (testCasesMergeResult.status === MergeStatus.ConflictsResolved ||
            testCasesMergeResult.status === MergeStatus.NoConflicts ||
            scriptsMergeResult.status === MergeStatus.ConflictsResolved ||
            scriptsMergeResult.status === MergeStatus.NoConflicts) {
            ToasterService.showInfo({
                title: messages.projectIsSyncedWithGithub,
            });
        }

        yield checkChangesToPush({ project, manually: false });
        yield put({ type: types.PULL_PROJECT_FROM_GITHUB_OK });

        if (resolve) {
            resolve();
        }
    } catch (error) {
        if (reject) {
            reject();
        }
        yield handleGithubIntegrationErrors(error);
    }
}

interface IScriptConflictInfo {
    localContent: string;
    remoteContent: string;
    name: string;
    text: string;
}

interface ITestCaseConflictInfo {
    localContent: string;
    remoteContent: string;
    name: string;
    text: string;
}

interface IRepoFile {
    name: string
}
interface IResolveConflictsInScripts {
    message: string;
    files: IRepoFile[];
    scripts: IScript[];
}

interface IResolveConflictResults {
    status: MergeStatus,
    itemsToUpdated: IScriptConflictInfo[] | ITestCaseConflictInfo[]
    itemsToAdd: IScriptConflictInfo[] | ITestCaseConflictInfo[]
}

export function* resolveConflictsInScripts({ files, scripts, message }
    : IResolveConflictsInScripts) {

    let {
        filesToAdd: scriptsToAdd,
        filesWithConflicts: scriptsWithConflicts,
    } = getDiffBetweenProjectAndRepo(scripts, files);

    scriptsWithConflicts = scriptsWithConflicts.filter(script => !!script.remoteContent);

    if (scriptsWithConflicts?.length > 0) {
        const { okBtnAction, cancelBtnAction } = yield confirmSaga.confirm({
            title: 'Warning',
            message,
            okBtnLabel: 'Merge',
        });
        if (okBtnAction) {
            return yield confirmAlert({
                customUI: ({ onClose, customUIOptions }) => {
                    return <MergeForm
                        files={scriptsWithConflicts}
                        finishMerge={(mergedScripts) => {
                            onClose();
                            customUIOptions.resolve({
                                status: MergeStatus.ConflictsResolved,
                                itemsToUpdated: mergedScripts,
                                itemsToAdd: scriptsToAdd
                            } as IResolveConflictResults);
                        }}
                        onClose={() => {
                            onClose();
                            customUIOptions.resolve({
                                status: MergeStatus.Canceled,
                            });
                        }} />;
                }
            });
        } else if (cancelBtnAction) {
            return {
                status: MergeStatus.Canceled
            } as IResolveConflictResults;
        }
    } else {
        return {
            status: MergeStatus.NoConflicts,
            itemsToAdd: scriptsToAdd
        } as IResolveConflictResults;
    }
}

export function* addRepoWithoutFiles({ project, repoUrl, folder, branch, repoPermissions, resolve, reject }: IAddRepoWithoutFilesToProjectParam) {
    try {
        yield saveGitHubProjectSettings({ project, repoUrl: buildFullRepoUrl({ repoUrl, folder, branch, commitSha: savedCommitSha }), repoPermissions });
        yield getGitHubProjectSettings({ projectId: project.projectId, testToken: false }); // todo: remove it?

        if (resolve) {
            resolve();
        }
    } catch (error) {
        if (reject) {
            reject();
        }
        yield handleGithubIntegrationErrors(error);
    }
}

export function* showAddGithubRepoUrlPopup({ project, environment }: IShowAddGithubRepoUrlPopupParam) {
    try {
        confirmAlert({
            customUI: ({ onClose }) => {
                return <AddGitHubRepositoryForm
                    store={store}
                    project={project}
                    environment={environment}
                    getOrganizationsByUser={() => {
                        store.dispatch({ type: types.GET_ORGANIZATIONS_BY_USER_REQ });
                    }}
                    getRepositoriesByUser={() => {
                        store.dispatch({ type: types.GET_REPOSITORIES_BY_USER_REQ });
                    }}
                    saveGitHubProjectSettings={({ repoUrl, repoPermissions }) => {
                        store.dispatch({ type: types.SAVE_GITHUB_PROJECT_SETTINGS_REQ, repoUrl, project, repoPermissions });
                        onClose();
                    }}
                    onClose={() => {
                        onClose();
                    }
                    } />;
            }
        });
    } catch (error) {
        yield handleGithubIntegrationErrors(error);
    }
}

export interface ISaveGitHubProjectSettingsParam extends IPromiseParam {
    repoUrl: string,
    project: IProject,
    repoPermissions?: object,
    environment?: Environment,
}

export function* saveGitHubProjectSettings({ repoUrl, project, repoPermissions, environment, resolve, reject }: ISaveGitHubProjectSettingsParam) {
    try {
        const projectId = project.projectId;
        const deployId = environment || '';
        yield put({ type: types.GITHUB_REQUEST_PROCESSING_REQ });
        yield call(Api.saveGitHubProjectSettings, repoUrl, projectId, repoPermissions, deployId);
        yield getGitHubProjectSettings({ projectId, testToken: false, environment });
        yield put({ type: types.GITHUB_REQUEST_PROCESSING_OK });
        yield put({ type: types.SAVE_GITHUB_PROJECT_SETTINGS_OK });

    } catch (error) {
        yield put({ type: types.GITHUB_REQUEST_PROCESSING_ERR });
        if (reject) {
            reject(error);
        }
        yield handleGithubIntegrationErrors(error);
    }
}

export function* pullProjectFromGithub({ project }: IPullProjectFromGithubParam) {
    try {

        const projectId = project.projectId;
        const tagId = project.stageTagId;
        const { gitUserProject, repoUrl } = store.getState().gitHubIntegration;
        const { path, branch, folder } = getRepoInfo(repoUrl);
        const branches = yield getBranchesByRepository({ repo: gitUserProject });
        const currentBranch = findCurrentBranch(branches, branch);
        const isValid = yield isBranchValid({ project, currentBranch, branches });

        if (!isValid) {
            yield put({ type: types.PULL_PROJECT_FROM_GITHUB_ERR });
            return false;
        }

        if (branches.length === 0) {
            ToasterService.showInfo({
                title: messages.projectIsSyncedWithGithub,
            });
            yield put({ type: types.PULL_PROJECT_FROM_GITHUB_OK });
            return;
        }
        const conversations = yield getConversations({ project });
        const scripts = yield projectsSaga.getScripts({ projectId, tagId });

        let { files } = yield call(GitHubApiHttp.getFilesByBranch, gitUserProject, currentBranch.commit.sha);

        files = getFilesByPath(files, path);
        for (let i = 0; i < files.length; i++) {
            files[i].content = yield call(GitHubApiHttp.getFileContent, files[i].url);
        }

        const { scriptsFiles, testCasesFiles } = getScriptsAndTestCasesFromFiles(files);
        const {
            filesToAdd: scriptsToAdd,
            filesWithConflicts: scriptsWithConflicts,
            isDiff: isDiffInScripts
        } = getDiffBetweenProjectAndRepo(scripts, scriptsFiles);

        const {
            isDiff: isDiffInConversations
        } = getDiffBetweenProjectAndRepo(conversations, testCasesFiles, compareTestCases, checkRemoteTestCaseFormat);

        if (!isDiffInScripts && !isDiffInConversations) {
            ToasterService.showInfo({
                title: messages.projectIsSyncedWithGithub,
            });
            yield saveCommitAfterAction({ project, commitSha: currentBranch.commit.sha });
            yield put({ type: types.PULL_PROJECT_FROM_GITHUB_OK });
            yield put({ type: types.CHECK_CHANGES_TO_PUSH_TO_GITHUB_OK, hasChangesToPush: false });
            yield put({ type: types.CHECK_CHANGES_TO_PULL_FROM_GITHUB_OK, hasChangesToPull: false });
            return;
        }

        const scriptsMergeResult: IResolveConflictResults = yield resolveConflictsInScripts({
            files: scriptsFiles,
            scripts,
            message: "You have conflicts with the remote repository in files: " + scriptsWithConflicts.map(script => `<b>${script.name}</b>`).join(', ') + ". What would you like to do?"
        });
        if (scriptsMergeResult.status === MergeStatus.ConflictsResolved ||
            scriptsMergeResult.status === MergeStatus.NoConflicts) {
            yield saveScripts({
                project,
                scriptsToAdd: scriptsMergeResult.itemsToAdd,
                scriptsToUpdate: scriptsMergeResult.itemsToUpdated,
                commitSha: currentBranch.commit.sha
            });
            yield put({ type: projectActionTypes.UPDATE_PROJECT_AFTER_MERGE_OK });
        }

        const testCasesMergeResult: IResolveConflictResults = yield resolveConflictsInTestCases({
            files: testCasesFiles,
            conversations
        });

        if (testCasesMergeResult.status === MergeStatus.ConflictsResolved ||
            testCasesMergeResult.status === MergeStatus.NoConflicts) {
            yield projectsSaga.importTestConversations({
                project,
                conversations: [
                    ...getConversationsFromRepoFiles(testCasesMergeResult.itemsToAdd),
                    ...(testCasesMergeResult.itemsToUpdated || []),
                ],
                initializerInfo: 'git'
            });
        }

        if ((testCasesMergeResult.status === MergeStatus.ConflictsResolved ||
            testCasesMergeResult.status === MergeStatus.NoConflicts) &&
            (scriptsMergeResult.status === MergeStatus.ConflictsResolved ||
                scriptsMergeResult.status === MergeStatus.NoConflicts)) {
            ToasterService.showInfo({ title: messages.projectIsSyncedWithGithub });
        }
        if (scriptsMergeResult.status === MergeStatus.Canceled ||
            testCasesMergeResult.status === MergeStatus.Canceled) {
            ToasterService.showInfo({ title: messages.projectIsNotSyncedWithGithub });
        }
        yield put({ type: types.PULL_PROJECT_FROM_GITHUB_OK });
    } catch (error) {
        yield handleGithubIntegrationErrors(error);
    }
}

export function* isBranchValid({ project, currentBranch, branches }) {
    let isValid = true;
    if (branches === undefined || (branches.length > 0 && !currentBranch)) {
        isValid = false;
        throw new Error('repo-or-branch-invalid');
    }
    return isValid;
}
interface IMergeAndSaveTestCasesParam {
    files: any[],
    conversations: IConversation[],
    addRepo?: boolean,
}
export function* resolveConflictsInTestCases({ files, addRepo, conversations }: IMergeAndSaveTestCasesParam) {
    let {
        filesToAdd: conversationsToAdd,
        filesWithConflicts: conversationsWithConflicts
    } = getDiffBetweenProjectAndRepo(conversations, files, compareTestCases, checkRemoteTestCaseFormat);

    conversationsWithConflicts = conversationsWithConflicts.filter(conversation => !!conversation.remoteContent);

    if (conversationsWithConflicts?.length > 0) {
        const { okBtnAction, cancelBtnAction } = yield confirmSaga.confirm({
            title: 'Warning',
            message: "You have conflicts with the remote repository in the following testcases: " + conversationsWithConflicts.map(({ name }) => `<b>${name}</b>`).join(', ') + ". What would you like to do?",
            okBtnLabel: 'Resolve Conflicts',
        });
        if (cancelBtnAction) {
            return { status: MergeStatus.Canceled };
        }
        if (okBtnAction) {
            return yield confirmAlert({
                customUI: ({ onClose, customUIOptions }) => {
                    return <Provider store={store}>
                        <MergeTestCasesForm
                            store={store}
                            files={conversationsWithConflicts}
                            finishMerge={(mergedFiles) => {
                                onClose();
                                customUIOptions.resolve({
                                    status: MergeStatus.ConflictsResolved,
                                    itemsToAdd: conversationsToAdd,
                                    itemsToUpdated: [
                                        ...mergedFiles.map(phrase => {
                                            return {
                                                ...phrase,
                                                phrases: phrase.resultPhrases
                                            };
                                        })
                                    ]
                                } as IResolveConflictResults);
                            }}
                            onClose={() => {
                                onClose();
                                customUIOptions.resolve({ status: MergeStatus.Canceled });
                            }} />
                    </Provider>;
                }
            });
        }
    } else {
        return {
            status: MergeStatus.NoConflicts,
            itemsToAdd: conversationsToAdd
        } as IResolveConflictResults;
    }
}

function getConversationsFromRepoFiles(conversations = []) {
    return conversations.map(conversation => {
        return {
            name: conversation.name.replace('.testcase', ''),
            phrases: JSON.parse(conversation.text)
        };
    });
}

interface IMergeAndSaveScriptsParam {
    project: IProject,
    scriptsToAdd: any[],
    scriptsToUpdate?: any[],
    repoUrl?: string,
    folder?: string,
    branch?: string,
    commitSha?: string,
    repoPermissions?: object,
}
export function* saveScripts({
    project,
    scriptsToAdd = [],
    scriptsToUpdate = [],
    repoUrl,
    folder,
    branch,
    commitSha,
    repoPermissions
}: IMergeAndSaveScriptsParam) {
    try {
        const { projectId, stageTagId: tagId } = project;

        for (let i = 0; i < scriptsToAdd.length; i++) {
            yield call(Api.createScript, project.projectId, scriptsToAdd[i].name, scriptsToAdd[i].text, scriptsToAdd[i].scriptType);
        }

        for (let i = 0; i < scriptsToUpdate.length; i++) {
            const curScript = scriptsToUpdate[i];
            if (curScript.text === '' && !curScript.remoteContent) {
                yield projectsSaga.deleteScript({
                    project,
                    scriptId: curScript.scriptId
                });
            } else {
                yield projectsSaga.updateScript({
                    project,
                    script: curScript,
                    environment: Environment.Staging,
                    manually: true,
                    apply: 0
                });
            }
        }

        if (commitSha) {
            yield saveCommitAfterAction({ project, commitSha });
            yield put({ type: types.CHECK_CHANGES_TO_PUSH_TO_GITHUB_OK, hasChangesToPush: false });
            yield put({ type: types.CHECK_CHANGES_TO_PULL_FROM_GITHUB_OK, hasChangesToPull: false });
        } else {
            if (repoUrl) {
                yield saveGitHubProjectSettings({ project, repoUrl: buildFullRepoUrl({ repoUrl, branch, folder, commitSha: savedCommitSha }), repoPermissions });
                yield getGitHubProjectSettings({ projectId: project.projectId, testToken: false }); // todo: remove it?
            }
        }
        const { scriptName } = getUrlInfo();
        const existingScripts = yield projectsSaga.getScripts({ projectId, tagId });
        if (existingScripts?.length > 0) {
            if (!scriptName || !_.find(existingScripts, { name: scriptName })) {
                yield put(push(routeInfo.projectScripts.url(project.name, existingScripts[0].name)));
            }
        }

    } catch (error) {
        yield handleGithubIntegrationErrors(error);
    }
}

function* saveCommitAfterAction({ project, commitSha }) {
    let { repoUrl } = store.getState().gitHubIntegration;
    const { commitSha: prevCommitSha } = getRepoInfo(repoUrl);
    repoUrl = repoUrl.replace(prevCommitSha, commitSha);

    yield saveGitHubProjectSettings({ project, repoUrl });
}


export function* pushTestCases({ project, resolve, reject }: IPushTestCasesParam) {
    try {
        const { gitUserProject, repoUrl } = store.getState().gitHubIntegration;
        const { path, commitSha, branch } = getRepoInfo(repoUrl);

        const conversations = yield getConversations({ project });
        const folder = path;
        const newPath = `${folder}${project.name}.testcase`;
        const treeInfo = yield call(GitHubApiHttp.getTree, gitUserProject, commitSha);

        console.log("current tree", treeInfo);
        let { files } = yield call(GitHubApiHttp.getFiles, treeInfo.tree.url);

        files = getFilesByPath(files, folder);
        files = files.filter(file => file.path !== newPath);
        files = [...files, {
            path: newPath,
            content: JSON.stringify(conversations),
        }];

        const newTree = yield call(GitHubApiHttp.createFileTree, gitUserProject, files, treeInfo.tree.sha);
        console.log("new tree", newTree);
        const message = new Date().toISOString();
        const commit = yield call(GitHubApiHttp.createCommit, gitUserProject, message, newTree.sha, [commitSha]);
        console.log("commit", message);
        const head = yield call(GitHubApiHttp.updateHead, gitUserProject, branch, commit.sha);
        console.log("update head", head);
    } catch (error) {
        yield handleGithubIntegrationErrors(error);
    }
}

function getDiffBetweenProjectAndRepo(projectFiles, repoFiles, compareFn?, checkFormatFn?) {
    const filesToDelete = [];
    const filesToAdd = [];
    const existingFiles = _.intersectionBy(
        projectFiles.map(file => file.name),
        repoFiles.map(files => files.name));

    let filesWithConflicts = [];

    for (let i = 0; i < repoFiles.length; i++) {
        const curRepoFile = repoFiles[i];
        if (!_.find(projectFiles, { name: curRepoFile.name })) {
            filesToAdd.push({
                name: curRepoFile.name,
                text: curRepoFile.content,
                scriptType: curRepoFile.scriptType
            });
        }
    }

    for (let i = 0; i < existingFiles.length; i++) {
        const curProjectFile = _.find(projectFiles, { name: existingFiles[i] });
        const curRepoFile = _.find(repoFiles, { name: existingFiles[i] });
        const hasDiff = compareFn ?
            compareFn(curRepoFile, curProjectFile) :
            curRepoFile.content !== curProjectFile.text;

        if (hasDiff && (checkFormatFn ? checkFormatFn(curRepoFile.content) : true)) {
            if (!_.find(filesToAdd, { name: curRepoFile.name })) {
                filesWithConflicts.push({
                    ...curProjectFile,
                    localContent: curProjectFile.text,
                    remoteContent: curRepoFile.content,
                });
            }
        }
    }

    for (let i = 0; i < projectFiles.length; i++) {
        const curProjectFile = projectFiles[i];
        if (!_.find(repoFiles, { name: curProjectFile.name })) {
            filesToDelete.push({
                ...curProjectFile,
                localContent: curProjectFile.text,
                remoteContent: '',
            });
        }
    }

    filesWithConflicts = [...filesWithConflicts, ...filesToDelete];

    return {
        filesToAdd,
        filesWithConflicts,
        isDiff: filesToAdd.length > 0 || filesWithConflicts.length > 0
    };
}

export function* pushProjectToGithub({ project, message }: IPushProjectToGithubParam) {
    try {
        const projectId = project.projectId;
        const tagId = project.stageTagId;
        const { gitUserProject, repoUrl } = store.getState().gitHubIntegration;
        let { path, commitSha, branch } = getRepoInfo(repoUrl);

        const hasChangesToPull = yield checkChangesToPull({ project });
        if (hasChangesToPull) {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <ChangesToPullForm onClose={onClose} />
                    );
                }
            });
            return;
        }

        const folder = path;
        const scripts = yield projectsSaga.getScripts({ projectId, tagId });
        const conversations = yield getConversations({ project });

        let files = [...scripts.map(script => ({
            path: `${folder}${script.name}${isScriptType(script) ? '.js' : '.transform.json'}`,
            content: script.text,
        })),
        ...conversations.map(conversation => {
            return {
                path: `${folder}${conversation.name}.testcase`,
                content: "/* Please do not make any changes directly in the file, only through our Platform, otherwise it won't work */\n" + JSON.stringify(conversation.phrases)
            };
        })];

        // repo completely empty
        if (!commitSha) {
            let initFile;

            if (files.length > 0) {
                initFile = files[0];
            } else {
                return;
            }
            branch = 'main';
            const { commit } = yield call(GitHubApiHttp.makeInitCommit, gitUserProject, message, branch, initFile);
            commitSha = commit.sha;
            yield saveGitHubProjectSettings({ project, repoUrl: buildFullRepoUrl({ repoUrl, branch, commitSha }) });
        }

        const treeInfo = yield call(GitHubApiHttp.getTree, gitUserProject, commitSha);

        console.log("current tree", treeInfo);
        let { files: filesFromGit } = yield call(GitHubApiHttp.getFiles, treeInfo.tree.url);

        filesFromGit = getFilesByPath(filesFromGit, folder);

        let filesToDelete = [];

        for (let i = 0; i < filesFromGit.length; i++) {
            if (_.findIndex(files, { path: filesFromGit[i].path }) === -1) {
                filesToDelete.push(filesFromGit[i]);
            }
        }

        filesToDelete = filesToDelete.map(file => ({ ...file, toDelete: true }));

        files = [...files, ...filesToDelete];

        // we remove everything from the folder - we need to put in the filder 
        // .gitempty, otherwise the folder will be removed
        if (filesToDelete.length > 0 && scripts.length === 0 && conversations.length === 0) {
            files = [...files, {
                path: `${folder}.gitempty`,
                content: ''
            }];
        }

        console.log("filesFromGit", filesFromGit);

        const newTree = yield call(GitHubApiHttp.createFileTree, gitUserProject, files, treeInfo?.tree?.sha);
        console.log("new tree", newTree);
        const commit = yield call(GitHubApiHttp.createCommit, gitUserProject, message, newTree.sha, [commitSha]);
        console.log("commit", commit);
        const head = yield call(GitHubApiHttp.updateHead, gitUserProject, branch, commit.sha);
        console.log("update head", head);
        yield put({ type: types.PUSH_PROJECT_TO_GITHUB_OK });
        ToasterService.showInfo({ title: "Your changes were pushed successfully" });
        yield saveCommitAfterAction({ project, commitSha: commit.sha });
        yield fillRemoteFiles(commit.sha);
        yield put({ type: types.CHECK_CHANGES_TO_PUSH_TO_GITHUB_OK, hasChangesToPush: false });
        yield put({ type: types.CHECK_CHANGES_TO_PULL_FROM_GITHUB_OK, hasChangesToPull: false });

    } catch (error) {
        yield put({ type: types.PUSH_PROJECT_TO_GITHUB_ERR });
        yield handleGithubIntegrationErrors(error);
    }
}

export function* removeGitHubProjectSettings({ project }: IRemoveGitHubProjectSettingsParam) {
    try {
        const { githubDeployId: deployId } = store.getState().gitHubIntegration;
        const { projectId } = project;

        if (deployId) {
            const { status, tagName } = yield confirmAlert({
                customUI: ({ onClose, customUIOptions }) => {
                    return <RemoveCiCdLinkAndSaveScriptsToTag
                        project={project}
                        onRemoveCiCdLink={({ tagName }: IRemoveCiCdLinkParam) => {
                            onClose();
                            customUIOptions.resolve({
                                status: tagName ? RemoveCiCdStatus.SaveWithNewName : RemoveCiCdStatus.SaveWithoutNewName,
                                tagName

                            });
                        }}
                        onClose={() => {
                            onClose();
                            customUIOptions.resolve({ status: RemoveCiCdStatus.Canceled });
                        }} />;
                }
            });

            if (status !== RemoveCiCdStatus.Canceled) {
                yield call(Api.removeGitHubProjectSettings, projectId, deployId, tagName);
                yield getGitHubProjectSettings({ projectId, testToken: false });
                yield projectsSaga.getProject({
                    projectId,
                    environment: deployId,
                    keepMessages: true,
                });
            }
        } else {
            yield call(Api.removeGitHubProjectSettings, projectId, deployId);
            yield getGitHubProjectSettings({ projectId, testToken: false });
        }

    } catch (error) {
        yield handleGithubIntegrationErrors(error);
    }
}

export function* checkChangesToPull({ project, resolve, reject, }: ICheckChangesToPullParam) {
    try {
        const { gitUserProject, repoUrl, hasGithubAccess } = store.getState().gitHubIntegration;

        if (!hasGithubAccess || !repoUrl) {
            if (resolve) {
                resolve(false);
            }
            return false;
        }

        const { commitSha, branch } = getRepoInfo(repoUrl);
        const branches = yield getBranchesByRepository({ repo: gitUserProject });
        const currentBranch = findCurrentBranch(branches, branch);
        const isValid = yield isBranchValid({ project, currentBranch, branches });
        if (!isValid) {
            if (reject) {
                reject(false);
            }
            return false;
        }

        let hasChangesToPull;

        if (branches.length === 0) {
            hasChangesToPull = false;
        } else {
            console.info('ALAN - check for pull');
            console.info('ALAN - check for pull - saved commit - ', commitSha);
            console.info('ALAN - check for pull - remote commit - ', currentBranch.commit.sha);

            hasChangesToPull = currentBranch.commit.sha !== commitSha;
        }

        yield put({ type: types.CHECK_CHANGES_TO_PULL_FROM_GITHUB_OK, hasChangesToPull });
        if (resolve) {
            resolve(hasChangesToPull);
        }
        return hasChangesToPull;
    } catch (error) {
        if (reject) {
            reject();
        }
        yield handleGithubIntegrationErrors(error);
    }
}


export function* checkChangesToPush({ project, manually, resolve, reject }: ICheckChangesToPushParam) {
    try {
        const projectId = project.projectId;
        const tagId = project.stageTagId;
        if (manually) {
            yield put({ type: types.CHECK_PUSH_STATUS_BEFORE_PUSH_REQ });
        }
        let hasChangesToPush = false;
        const { gitUserProject, repoUrl, hasGithubAccess } = store.getState().gitHubIntegration;
        if (!hasGithubAccess || !repoUrl) {
            return;
        }

        const { commitSha, branch } = getRepoInfo(repoUrl);
        const branches = yield getBranchesByRepository({ repo: gitUserProject });
        const currentBranch = findCurrentBranch(branches, branch);
        const isValid = yield isBranchValid({ project, currentBranch, branches });
        if (!isValid) {
            if (reject) {
                reject();
            }
            yield put({ type: types.PUSH_PROJECT_TO_GITHUB_ERR });
            return false;
        }

        const scripts = yield projectsSaga.getScripts({ projectId, tagId });
        let conversations = yield getConversations({ project });

        if (branches.length === 0) {
            hasChangesToPush = scripts.length > 0 || conversations.length > 0;
        } else {
            console.info('ALAN - check for push');
            console.info('ALAN - check for push - saved commit - ', commitSha);
            console.info('ALAN - check for push - remote commit - ', currentBranch?.commit?.sha);

            if (currentBranch?.commit?.sha !== commitSha) {
                hasChangesToPush = true;
            } else {
                const remoteFiles = yield fillRemoteFiles(currentBranch.commit.sha);
                const scripts = yield projectsSaga.getScripts({ projectId, tagId });

                conversations = conversations.map(conversation => {
                    return {
                        ...conversation,
                        text: JSON.stringify(conversation.phrases)
                    };
                });
                const { scriptsFiles, testCasesFiles } = getScriptsAndTestCasesFromFiles(remoteFiles);
                const diffInScripts = getDiffBetweenProjectAndRepo(scripts, scriptsFiles).isDiff;
                const diffInTestCases = getDiffBetweenProjectAndRepo(conversations, testCasesFiles, compareTestCases).isDiff;
                hasChangesToPush = diffInScripts || diffInTestCases;
            }
        }

        yield put({ type: types.CHECK_CHANGES_TO_PUSH_TO_GITHUB_OK, hasChangesToPush });
        yield put({ type: types.CHECK_PUSH_STATUS_BEFORE_PUSH_OK });
        if (resolve) {
            resolve(hasChangesToPush);
        }
    } catch (error) {
        if (reject) {
            reject();
        }
        yield handleGithubIntegrationErrors(error);
    }
}

function checkRemoteTestCaseFormat(content) {
    try {
        const node1 = new Node();
        const tree1 = node1.getTree(JSON.parse(content));
        const dialogs = tree1.toDialogs({}, 0);
        const html = renderToStaticMarkup(
            <Provider store={store}>
                <Dialog
                    dialogTree={tree1}
                    dialog={dialogs[Object.keys(dialogs)[0]]}
                    index={0} />
            </Provider>
        );
        return true;
    } catch (e) {
        return false;
    }
}

function findCurrentBranch(branches, branchName) {
    let branch = _.find(branches, (branch) => branch.name === branchName);
    if (branch) {
        return branch;
    }
    branch = _.find(branches, (branch) => branch.name === 'main' || branch.name === 'master');
    return branch;
}

function findBranch(branch) {
    if (branch.name === branch) {
        return true;
    }
    return false;
}

function compareTestCases(remoteTestCase, localTestCase) {
    const node1 = new Node();
    const tree1 = node1.getTree(JSON.parse(remoteTestCase.content));
    const node2 = new Node();
    const tree2 = node2.getTree(localTestCase.phrases);
    return !tree1.isValuesEqual(tree2);
}

function* getConversations({ project }) {
    const conversations = yield projectsSaga.exportTestConversations({
        project: {
            ...project,
            conversations: yield projectsSaga.getTestConversations({ projectId: project.projectId })
        }
    });
    return conversations;
}

function* fillRemoteFiles(commitSha) {
    const { gitUserProject, repoUrl, hasGithubAccess } = store.getState().gitHubIntegration;

    if (!repoUrl) {
        return;
    }

    const { path } = getRepoInfo(repoUrl);
    let { files } = yield call(GitHubApiHttp.getFilesByBranch, gitUserProject, commitSha);
    files = getFilesByPath(files, path);
    for (let i = 0; i < files.length; i++) {
        files[i].content = yield call(GitHubApiHttp.getFileContent, files[i].url);
    }
    return files;
}

function getScriptsAndTestCasesFromFiles(files = []) {
    const scriptsFiles = files.filter(file => file.path.indexOf('.transform.json') > -1 || file.path.indexOf('.js') > -1);
    const testCasesFiles = files.filter(file => file.path.indexOf('.testcase') > -1).map(file => {
        return {
            ...file,
            content: file.content.substr(file.content.indexOf('['), file.content.length)
        };
    });
    return {
        scriptsFiles,
        testCasesFiles
    };
}

export function* checkProjectForUnsavedChanges({ project, gitAction, resolve, reject }: ICheckProjectForUnsavedChangesParam) {
    try {
        let hasUnsavedChanges = false;

        for (let i = 0; i < project.scripts.length; i++) {
            const hasDraft = yield call(scriptDraftService.hasDraft, project.scripts[i].scriptId);
            if (hasDraft) {
                hasUnsavedChanges = true;
                break;
            }
        }

        if (hasUnsavedChanges) {
            const { okBtnAction, cancelBtnAction } = yield confirmSaga.confirm({
                title: 'Warning',
                message: "You have unsaved changes in your project. Please save them before " + gitAction + "ing the changes.",
                okBtnLabel: 'Save',
            });

            if (okBtnAction) {
                yield projectsSaga.updateScripts({ project, environment: Environment.Staging });
                resolve();
            }
            if (cancelBtnAction) {
                return;
            }
        } else {
            resolve();
        }
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export function* handleGithubIntegrationErrors(errorData) {
    if (errorData.message === 'Bad credentials') {
        yield put({
            type: types.GITHUB_CREDENTIALS_ERR,
            hasGithubToken: false,
            hasGithubAccess: false,
        });
        return;
    }
    if (errorData.message === 'Not Found') {
        yield put({
            type: types.GITHUB_CREDENTIALS_ERR,
            hasGithubToken: true,
            hasGithubAccess: false,
        });
        return;
    }

    if (errorData.message === 'Failed to fetch' && !navigator.onLine) {
        yield put({ type: types.PULL_PROJECT_FROM_GITHUB_ERR });
        yield put({ type: types.PUSH_PROJECT_TO_GITHUB_ERR });
        ToasterService.showError({
            preventDuplicates: true,
            title: 'Your are offline. Please re-check your connection and repeat'
        });
        return;
    }

    if (errorData.message === 'repo-or-branch-invalid') {
        if (navigator.onLine) {
            ToasterService.showError({
                preventDuplicates: true,
                title: 'Repository or branch that you synced with is not found, please add it to your project again'
            });
        }
        return;
    }

    if (errorData.error === errorCodes.noGithubLogin) {
        clearEncGitHubToken();
        yield put({ type: userActionTypes.GET_GITHUB_LOGIN_NAME_ERR });
        return;
    }

    if ([
        errorCodes.undefinedGithubToken,
        errorCodes.invalidGithubToken,
    ].indexOf(errorData.error) === -1) {
        console.log(errorData);
        if (errorData.error !== errorCodes.noGithubRepoScope && errorData.error !== 'github-api-error') {
            yield errorSaga.putError(errorData);
        }
    }
}

export function* revokeGithubAccess() {
    try {
        const { okBtnAction } = yield confirmSaga.confirm({
            title: 'Warning',
            message: 'Are you sure you want to revoke access for the Alan AI application in your GitHub account? After revoking, sync with GitHub repositories and GitHub starring benefits will be disabled. To enable these features, you will need to sync with GitHub again.',
            okBtnLabel: 'Revoke',
        });

        if (okBtnAction) {
            const encGithubToken = getEncGitHubToken();
            yield call(Api.revokeGithubAccess, encGithubToken);
            clearEncGitHubToken();
            clearGitHubTokenAndScope();
            yield put({ type: types.REVOKE_GITHUB_ACCESS_OK });
            yield userSaga.getProfile();
        }
    } catch (error) {
        yield handleGithubIntegrationErrors(error);
    }
}
